import reduce from 'lodash/reduce';

/** Takes an object, and returns it with all string properties trimmed */
export const trimObject = (obj: Record<string, unknown>) =>
  reduce<any, any>(
    obj,
    (acc, val, key) => {
      if (typeof val === 'string') {
        return {
          ...acc,
          [key]: val.trim(),
        };
      }

      return {
        ...acc,
        [key]: val,
      };
    },
    {},
  );
